import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { GlobalService } from '@solar/services/global.service';
import { BaseComponent } from '@solar/shared';

import { CompanyTypeEnum } from 'solar-bo';

import { ControlEnum } from 'solar-bo';

declare const $: any;
declare interface RouteInfo {
  path: string;
  title: string;
  type: 'STD', icon:  string;
  class: string;
  submenu?: RouteInfo[];
  submenuid?: string;
  role?: number;
}

@Component({
  selector: 'app-frms-sidebar',
  templateUrl: './sidebar-a.component.html',
  styleUrls: ['./sidebar-a.component.scss']
})
export class SidebarComponent extends BaseComponent implements OnInit {


  backGroundColor = 'darkblue';
  @Input() version = 0;
  @Output() elemSelectedEvent:EventEmitter<any>=new EventEmitter();
  menuItems: any[] = new Array();
  showVerifierLogo:boolean=true;

  constructor(

  ) {
    super();
    this.checkVerifierLogo();
    this.backGroundColor= this.globService.ui_main_options.palette;
    this.globService.uiMainOptionsEvent.subscribe(res=>this.ui_main_optionsEventHandler(res));
  }

  ui_main_optionsEventHandler(ui_options){
    this.backGroundColor=ui_options.palette;
  }

  checkVerifierLogo(){
    let company=this.globService.company;
    if (company.info.hasOwnProperty("configUI")){
      let cfg=company.info["configUI"];
      if ( cfg.hasOwnProperty("showVerifierLogo")){
        this.showVerifierLogo=cfg["showVerifierLogo"];
      }
    }
  }

  ngOnInit() {

    let company_type_std: CompanyTypeEnum = this.globService.companyTypeStandard();
    if (company_type_std == CompanyTypeEnum.STD) {
      this.menuItems.push({ header: true, title: 'Solar System' });
    }
    else {
      this.menuItems.push({ header: true, title: 'Verifier System' });
    }
    let auth: boolean;
    auth = this.globService.checkAuthorizationById(ControlEnum.SEC_DASHBOARD);
    if (auth) {
      this.menuItems.push({ title: 'DashBoard', path: '/solar/dashboard', type: 'STD', icon:  'fas fa-tachometer-alt', tooltip: 'Portfolio status dashboard' });
    }
    auth = this.globService.checkAuthorizationById(ControlEnum.SEC_SITE);
    if (auth) {
      this.menuItems.push({ title: 'Sites', path: '/solar/sites', type: 'STACKED', icon:  'fas fa-globe-americas' });      
    }

    auth = this.globService.checkAuthorizationById(ControlEnum.SEC_SUPERVISION);
    if (auth) {
      this.menuItems.push({ title: 'Supervisions', path: '/solar/supervision-list', type: 'STD', icon:  'far fa-eye' });
    }
    auth = this.globService.checkAuthorizationById(ControlEnum.SEC_DASHBOARD_COMPARER);
    if (auth) {
      this.menuItems.push({ title: 'Comparer', path: '/solar/supervisioncomparer', type: 'STD', icon:  'fas fa-clone', tooltip: 'Compare Sites supervisions' });
    }

/*     auth=this.globService.checkAuthorizationById(ControlEnum.SEC_FLIGHT_OPERATOR);
    if (auth){
      this.menuItems.push({title: 'Flights', path: '/solar/operator-flight-list', type: 'STD', icon:  'fab fa-telegram-plane'});
    }   */
    

    auth = this.globService.checkAuthorizationById(ControlEnum.SEC_ADMIN);
    if (auth) {
      if (company_type_std == CompanyTypeEnum.STD) {
        this.menuItems.push({ header: true, title: 'Solar Admin' });
      }
      else {
        this.menuItems.push({ header: true, title: 'System Admin' });
      }
      this.menuItems.push({ title: 'Users', path: '/users/users-list', type: 'STD', icon:  'fas fa-users', tooltip: 'Admin users' });
      if (company_type_std == CompanyTypeEnum.STD) {
        this.menuItems.push({ title: 'Verifier', path: '/verifiers/verifier-detail', type: 'STD', icon:  'fas fa-users', tooltip: 'Verifier Company' });
        //this.menuItems.push({title: 'Flight Operators', path: '/flightoperators/list', type: 'STD', icon:  'fas fa-users', tooltip:'Flight operators for supervisions'});
      }
      if (company_type_std == CompanyTypeEnum.VERIFIER) {
        this.menuItems.push({ title: 'Panel Types', path: '/solar/paneltypes', type: 'STD', icon:  'fas fa-th-large', tooltip: 'System panel types' });
      }
      
    }
    //this.menuItems.push({title: 'In Process', path: '/solar/sitesinprocess', type: 'STD', icon:  'far fa-edit'});
  }

  togglemenu() {

  }
  sidebarclass="";
  toggleSideBar(){
    this.sidebarclass="off-canvas-sidebar";
    console.log("toggleSideBar");
  }
  routerActive=true;
  navigateTo(item){

    if (this.routerActive){
      this.router.navigate([item.path]);
    }else{
      this.globService.menuSelectedEvent_raise(item);
    }
  }
}
